<template>
  <v-card outlined>
    <div class="d-flex justify-space-between align-items-center pa-6">
      <h5 class="text-uppercase align-self-center grey--text">Lịch sử chăm sóc</h5>
    </div>
    <div class="timeline px-6 pb-2">
      <div v-for="item in items" :key="item.id" class="timeline-item">
        <div class="timeline-time">{{ item.time | ddmmyyyyhhmm }}</div>
        <div class="timeline-divider-container">
          <div class="timeline-divider">
            <span class="timeline-dot"></span>
          </div>
        </div>

        <div class="timeline-info">
          <div>{{ formatLog(item) }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment'
import formatLead from '@/helpers/translateLead.js'
import { mapGetters } from 'vuex'

export default {
  computed: { ...mapGetters({ items: 'leadLog/items' }) },
  methods: {
    formatLog(item) {
      if (!item.oldValue) item.oldValue = 'undefined'
      if (!item.newValue) item.newValue = 'undefined'

      const time = moment(item.time)
      const lastUpdated = moment(item.lastUpdatedAt)
      const updatedTime = this.formatUpdateTime(time, lastUpdated)

      switch (item.actionType) {
        case 'update':
          if (item.field === 'status') {
            return `${item.actionByName} đã cập nhật ${formatLead(item.field).toLowerCase()} từ "${formatLead(
              item.oldValue
            )}" sang "${formatLead(item.newValue)}" sau ${updatedTime}`
          } else {
            return `${item.actionByName} đã cập nhật ${formatLead(item.field).toLowerCase()} từ "${formatLead(
              item.oldValue
            )}" sang "${formatLead(item.newValue)}"`
          }

        case 'create':
          return `${item.actionByName} đã tạo khách hàng này`
        default:
          return `${item.actionByName} đã thực hiện một thao tác không hợp lệ`
      }
    },
    formatUpdateTime(time1, time2) {
      const min = time1.diff(time2, 'minutes')
      if (min < 60) return min + ' phút'
      if (min < 1440) return Math.round(min / 60) + ' giờ'
      return Math.round(min / 1440) + ' ngày'
    },
  },
}
</script>

<style scoped>
.timeline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.timeline-item {
  display: flex;
  align-items: stretch;
  min-height: 30px;
  color: #b0bec5;
}

.timeline-time {
  margin-right: 20px;
  padding-bottom: 16px;
}

.timeline-divider-container {
  flex: 1;
  display: flex;
}

.timeline-divider {
  flex-grow: 1;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 100%;
}

.timeline-divider::before {
  content: '';
  position: relative;
  height: 100%;
  border-left: 2px solid #b0bec5;
}
.timeline-item:first-child .timeline-divider::before {
  top: 40%;
}

.timeline-item:last-child .timeline-divider::before {
  bottom: 55%;
}
.timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #b0bec5;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.timeline-dot::after {
  content: '';
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.timeline-info {
  margin-left: 20px;
}
.timeline-item:last-child {
  color: black;
}
.timeline-item:last-child .timeline-dot {
  background-color: green;
}
.timeline-item:only-child .timeline-divider::before {
  display: none;
}
</style>
